import React from "react";
import "./index.scss";
import { RichTextBody, Modal } from "@nrg-storybook/reliant-component-library";
import { useTranslation } from "react-i18next";
import cirroLoader from "../../images/cirroloader.gif";

interface LoadingProps {
  msg?: string;
  show: any;
}


const LoadingComponent = ({ show, msg }: LoadingProps) => {
  const { t } = useTranslation();

  return show ? (
    <Modal
      show={show}
      showTitleBar={false}
      titleText=""
      modalType="dialog"
      modalClassName="loader-modal"
      hideCloseButton
      modalSize="Extra Large"
      showActionSlot={false}
      sizes="Small"
    >
      <div className="text-center loaderContent">
        <div className="loaderImg">
          <img src={cirroLoader} alt="Loading..." width="48" height="48" />
        </div>
        <RichTextBody tag="p" text={t("productChart:loading.please_wait")} />
      </div>
    </Modal>
  ) : null;
};

export default LoadingComponent;
